// Formatta e localizza la data di pubblicazione dei comunicati nella lingua attiva.
// Accetta ISO (2026-06-05) o testo italiano "DD MeseNome YYYY" (es. "05 Giugno 2026").
// In caso di formato non riconosciuto restituisce la stringa originale.

const LOCALE = { it: "it-IT", en: "en-US", fr: "fr-FR", de: "de-DE", es: "es-ES" };

const IT_MONTHS = {
  gennaio: 0, febbraio: 1, marzo: 2, aprile: 3, maggio: 4, giugno: 5,
  luglio: 6, agosto: 7, settembre: 8, ottobre: 9, novembre: 10, dicembre: 11,
};

function parseDate(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return d;
  }
  const m = s.toLowerCase().match(/(\d{1,2})\s+([a-zà-ù]+)\s+(\d{4})/);
  if (m && IT_MONTHS[m[2]] !== undefined) {
    const d = new Date(Number(m[3]), IT_MONTHS[m[2]], Number(m[1]));
    if (!Number.isNaN(d.getTime())) return d;
  }
  return null;
}

export function formatReleaseDate(raw, lang) {
  const s = String(raw || "").trim();
  const d = parseDate(s);
  if (!d) return s;
  try {
    return new Intl.DateTimeFormat(LOCALE[lang] || "it-IT", {
      day: "numeric", month: "long", year: "numeric",
    }).format(d);
  } catch {
    return s;
  }
}
